export default __webpack_public_path__ + "static/media/box-remove.9422597a.svg";